import { Zap } from "lucide-react";

export const UrgentBadge = ({ testid }) => (
  <span className="text-[10px] uppercase tracking-[0.15em] px-2 py-1 bg-[#E5484D] text-white font-semibold inline-flex items-center gap-1" data-testid={testid}>
    <Zap className="w-3 h-3 fill-current" />Urgente
  </span>
);
